<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndt"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndt'></dynamic-field></div>
  <div class='lgr_08 col_13'><dynamic-field [id]='"scrntm"' [size]=8 [line]=1 [column]=13 [(ngModel)]='scrntm'></dynamic-field></div>
  <div class='lgr_12 col_35'><span class='brt high default' id='text1'>NRPC - STARS</span>  </div>
  <div class='lgr_05 col_75'><span class='brt high default' id='text2'>S101G</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_52 col_14'><span class='brt high default' id='text3'>CREDIT CARD SECURITY AUTHORIZATION TABLE MAINTENANCE</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_61 col_09'><span class='brt high default' id='text4'>ENTER USER ID, AUTHORIZATION INDICATORS AND OPTIONAL COMMENTS</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_42 col_18'><span class='brt high default' id='text5'>(ONLY USER ID NEEDED WHEN SELECTING ENTER)</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_55 col_11'><span class='brt high default' id='text6'>(BELOW FIELDS ARE NOT NEEDED WHEN SELECTING PF1 OR PF2)</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_28'><span class='brt high default' id='text7'>USER ID:</span>  </div>
  <div class='lgr_08 col_37'><dynamic-field [id]='"userid"' [size]=8 [line]=11 [column]=37 [(ngModel)]='userid'></dynamic-field></div>
  <div class='lgr_00 col_46'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_16 col_20'><span class='brt high default' id='text9'>ADMIN AUTHORITY:</span>  </div>
  <div class='lgr_01 col_37'><dynamic-field [id]='"authind"' [size]=1 [line]=13 [column]=37 [(ngModel)]='authind'></dynamic-field></div>
  <div class='lgr_00 col_39'>  </div>
  <div class='lgr_08 col_42'><span class='brt high default' id='text11'>(Y OR N)</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_27 col_09'><span class='brt high default' id='text12'>CREDIT CARD VIEW AUTHORITY:</span>  </div>
  <div class='lgr_01 col_37'><dynamic-field [id]='"credind"' [size]=1 [line]=15 [column]=37 [(ngModel)]='credind'></dynamic-field></div>
  <div class='lgr_00 col_39'>  </div>
  <div class='lgr_08 col_42'><span class='brt high default' id='text14'>(Y OR N)</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_27'><span class='brt high default' id='text15'>COMMENTS:</span>  </div>
  <div class='lgr_40 col_37'><dynamic-field [id]='"commnts"' [size]=40 [line]=17 [column]=37 [(ngModel)]='commnts'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_35 col_29'><span class='brt high default' id='text16'>(REASON FOR MAINTENANCE - OPTIONAL)</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln"' [size]=79 [line]=22 [column]=1 [(ngModel)]='msgln'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_04 col_01'><span class='brt high default' id='text17'>PF: </span>  </div>
  <div class='lgr_19 col_06'><span class='brt high default' id='text18'>1-LIST ACTIVE USERS</span>  </div>
  <div class='lgr_16 col_27'><span class='brt high default' id='text19'>2-LIST ALL USERS</span>  </div>
  <div class='lgr_17 col_45'><span class='brt high default' id='text20'>4-RETURN TO STARS</span>  </div>
  <div class='lgr_05 col_64'><span class='brt high default' id='text21'>5-ADD</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_06'><span class='brt high default' id='text22'>6-UPDATE</span>  </div>
  <div class='lgr_08 col_16'><span class='brt high default' id='text23'>9-DELETE</span>  </div>
  <div class='lgr_24 col_26'><span class='brt high default' id='text24'>ENTER-LIST A SINGLE USER</span>  </div>
</div>
</div>
